export default __webpack_public_path__ + "static/media/firebase_logo.f1e482b5.png";